import styled from "@emotion/styled";
import { genericStyles } from "../../../constant";

export const StyledLandingPage = styled.div`
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    sans-serif;
  padding: 0px 30px;

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 46px;
    padding: 0 20px;
    border-radius: 14px;
    font-weight: 750;
    border: 1px solid transparent;
    transition: 0.2s ease;
    cursor: pointer;
  }
  .btn-primary {
    background: var(--gradient);
    color: #fff;
    box-shadow: 0 12px 28px rgba(70, 43, 115, 0.23);
  }
  .btn-primary:hover {
    background: var(--gradient-hover);
    transform: translateY(-1px);
  }
  .btn-secondary {
    background: #fff;
    border-color: #e7e1f1;
    color: #3d3548;
  }
  .btn-secondary:hover {
    border-color: #cabce2;
    transform: translateY(-1px);
  }
  .content-div {
    margin-top: 100px;
    max-width: 1500px;
    border-radius: 20px;
    padding: 20px 100px;
    margin-bottom: 20px;
  }

  @media (max-width: 950px) {
    .content-div {
      padding: 20px;
    }
  }

  .section-title {
    font-size: 40px;
    font-weight: 600;
    margin: 14px 0px;
  }
  .section-sub-title {
    font-size: 20px;
    font-weight: 300;
    color: #6b7280;
    margin-bottom: 30px;
    max-width: 700px;
  }

  .section-label {
    color: var(--primary);
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    font-weight: 850;
  }
  .section-padding {
    padding: 0 20px;
  }
  .even-section {
    background: #f1f3f699;
    padding-top: 50px;
    padding-bottom: 50px;
    border-radius: 5px;
  }
`;

export const StyledTopBar = styled.div`
  width: 100%;
  position: fixed;
  background: var(--primary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 200;
  .left-section {
    gap: 12px;
  }

  .top-div {
    padding: 16px 16px;
  }

  .right-section {
    width: 70%;
  }

  .logo {
    width: 48px;
    height: 48px;
    background: white;
    img {
      object-fit: contain;
      height: 33px;
    }
  }

  .brand-text {
    font-size: 18px;
    font-weight: 500;
    color: white !important;
  }

  .nav-menu {
    border: none;
    background: transparent;
    flex: 1;
    min-width: 0;
    .ant-menu-item {
      color: white;
    }
    .ant-menu-item-selected {
      color: var(--green) !important;
    }

    .ant-menu-item:hover {
      color: var(--green) !important;
    }

    .ant-menu-item:hover::after {
      border-bottom-color: var(--green) !important;
    }

    .ant-menu-item-selected::after {
      border-bottom-color: var(--green) !important;
    }

    .ant-menu-item {
      font-size: 15px;
      font-weight: 500;
      padding: 0 16px;
    }
    .start-trial-btn {
      background: var(--green) !important;
      color: white !important;
      font-weight: bold;
    }
  }
`;

export const StyledHeroSection = styled.section`
  /* .hero { */
  padding: 20px 0 64px;
  /* } */
  .hero-grid {
    display: grid;
    grid-template-columns: 1.03fr 0.97fr;
    gap: 64px;
    align-items: center;
  }
  .eyebrow {
    display: inline-flex;
    gap: 8px;
    align-items: center;
    padding: 8px 12px;
    border-radius: 999px;
    background: #eee7ff;
    color: #7b3bea;
    font-size: 13px;
    font-weight: 800;
    margin-bottom: 22px;
  }
  h1 {
    font-size: clamp(48px, 6.8vw, 78px);
    line-height: 1.02;
    letter-spacing: -0.055em;
    margin: 0 0 24px;
  }
  p {
    font-size: 19px;
    color: #6f687e;
    max-width: 650px;
    margin: 0 0 30px;
  }
  .hero-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }
  .hero-note {
    font-size: 13px;
    color: #81798d;
    margin-top: 15px;
  }
  .product {
    position: relative;
    border-radius: 28px;
    padding: 16px;
    background: linear-gradient(160deg, #ffffff, #f2ecff);
    border: 1px solid #e6dcf5;
    box-shadow: 0 18px 55px rgba(70, 43, 115, 0.12);
    transform: rotate(0.6deg);
  }
  .window {
    overflow: hidden;
    border-radius: 20px;
    background: #fff;
    border: 1px solid #e7e1f1;
  }
  .window-bar {
    height: 44px;
    background: #faf8ff;
    border-bottom: 1px solid #e7e1f1;
    display: flex;
    align-items: center;
    padding: 0 14px;
    gap: 7px;
  }
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #d8cee8;
  }
  .app {
    display: grid;
    grid-template-columns: 150px 1fr 165px;
    min-height: 470px;
  }
  .sidebar {
    background: #f8f5fd;
    border-right: 1px solid #e7e1f1;
    padding: 18px 12px;
  }
  .side-logo {
    height: 28px;
    width: 74px;
    background: #d9c9f3;
    border-radius: 9px;
    margin-bottom: 18px;
  }
  .side-item {
    height: 30px;
    border-radius: 9px;
    background: #eee8f6;
    margin: 8px 0;
  }
  .side-item.active {
    background: #7b5ab8;
  }
  .chat {
    padding: 18px;
    background: #fff;
  }
  .chat-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e7e1f1;
    padding-bottom: 14px;
  }
  .avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: linear-gradient(145deg, #c1a7ed, #7955b8);
  }
  .person {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .name {
    height: 10px;
    width: 100px;
    background: #d8cfdf;
    border-radius: 8px;
  }
  .sub {
    height: 8px;
    width: 72px;
    background: #eee9f2;
    border-radius: 8px;
    margin-top: 7px;
  }
  .messages {
    padding: 24px 0;
  }
  .msg {
    width: 74%;
    padding: 13px;
    border-radius: 15px;
    background: #f2eef7;
    margin: 12px 0;
  }
  .msg.right {
    margin-left: auto;
    background: #7b3bea;
  }
  .msg-line {
    height: 7px;
    background: rgba(83, 67, 101, 0.22);
    border-radius: 5px;
    margin: 6px 0;
  }
  .msg.right .msg-line {
    background: rgba(255, 255, 255, 0.45);
  }
  .composer {
    height: 44px;
    border: 1px solid #e7e1f1;
    border-radius: 13px;
    margin-top: 42px;
    background: #faf9fc;
  }
  .workspace {
    background: #faf8fd;
    border-left: 1px solid #e7e1f1;
    padding: 16px 12px;
  }
  .work-title {
    height: 12px;
    width: 85px;
    background: #d6c9e3;
    border-radius: 7px;
    margin-bottom: 16px;
  }
  .work-card {
    background: #fff;
    border: 1px solid #e7e1f1;
    border-radius: 12px;
    padding: 10px;
    margin: 10px 0;
  }
  .work-icon {
    width: 26px;
    height: 26px;
    border-radius: 8px;
    background: #e8def8;
    margin-bottom: 9px;
  }
  .work-line {
    height: 7px;
    background: #ded5e7;
    border-radius: 5px;
    margin: 5px 0;
  }
  .float-card {
    position: absolute;
    background: #fff;
    border: 1px solid #e7e1f1;
    box-shadow: 0 16px 40px rgba(53, 34, 85, 0.15);
    border-radius: 16px;
    padding: 14px 16px;
    font-size: 13px;
    font-weight: 750;
  }
  .float-one {
    left: -38px;
    bottom: 62px;
  }
  .float-two {
    right: -28px;
    top: 72px;
  }
  @media (max-width: 950px) {
    padding-top: 58px;
    .hero-grid,
    .problem-grid,
    .agentify {
      grid-template-columns: 1fr;
    }
    .product {
      margin-top: 20px;
    }
    .cards {
      grid-template-columns: repeat(2, 1fr);
    }
    .three {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 650px) {
    h1 {
      font-size: 47px;
    }
    p {
      font-size: 17px;
    }
    .app {
      grid-template-columns: 90px 1fr;
    }
    .workspace {
      display: none;
    }
    .cards {
      grid-template-columns: 1fr;
    }
  }
`;

export const StyledAboutSection = styled.section`
  margin-bottom: 50px;
  .agentify {
    display: grid;
    grid-template-columns: 1.35fr 0.65fr;
    gap: 40px;
    align-items: center;
    background: linear-gradient(135deg, #f2ecff, #ffffff);
    border: 1px solid #e1d5f4;
    border-radius: 30px;
    padding: 46px;
  }
  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
  }
  @media (max-width: 950px) {
    .agentify {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 650px) {
    .agentify {
      padding: 27px;
    }
  }
`;

export const StyledFeaturesSection = styled.section`
  margin-top: 80px;
  margin-bottom: 50px;
  .features-container {
    padding: 50px 0px;
    margin: 0 auto;
    @media (max-width: 768px) {
      padding: 60px 0px;
    }
  }

  .icon-wrapper {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    transition: all 0.3s ease;

    &.purple-bg {
      background-color: #ede9fe;
    }

    &.blue-bg {
      background-color: #dbeafe;
    }
    &.yellow-bg {
      background-color: #fef3c7;
    }

    &.green-bg {
      background-color: #d1fae5;
    }

    &.orange-bg {
      background-color: #fee2e2;
    }

    &.pink-bg {
      background-color: #fce7f3;
    }

    &.cyan-bg {
      background-color: #cffafe;
    }
  }

  .feature-icon {
    font-size: 35px;
    transition: all 0.3s ease;

    &.purple-icon {
      color: ${genericStyles.primaryColor};
    }

    &.blue-icon {
      color: #3b82f6;
    }

    &.green-icon {
      color: #10b981;
    }

    &.yellow-icon {
      color: #f59e0b;
    }
    &.orange-icon {
      color: #ef4444;
    }

    &.pink-icon {
      color: #ec4899;
    }

    &.cyan-icon {
      color: #06b6d4;
    }
  }

  .feature-card {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 32px 24px;
    height: 100%;
    transition: all 0.3s ease;
    cursor: pointer;
    background: #ffffff;

    &:hover {
      border-color: ${genericStyles.primaryColor} !important;
      box-shadow: 0 8px 24px rgba(124, 58, 237, 0.12);
      transform: translateY(-4px);
    }

    .ant-card-body {
      padding: 0;
    }
  }

  .feature-card:hover .icon-wrapper {
    transform: scale(1.1);
  }

  .feature-card:hover .feature-icon {
    transform: rotate(5deg);
  }

  .feature-card-header {
    gap: 8px;
    .icon-wrapper {
      margin-bottom: 0px !important;
    }
    margin-bottom: 20px !important;
  }

  .feature-title {
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    margin: 0;
    line-height: 1.4;

    @media (max-width: 576px) {
      font-size: 18px;
    }
  }
  .feature-sub-title {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
    margin: 10px 0 0 0;
    line-height: 1.4;
    @media (max-width: 576px) {
      font-size: 14px;
    }
  }

  .feature-description {
    font-size: 14px;
    color: #6b7280;
    margin: 12px 0 0 0;
    line-height: 1.6;
  }

  .feature-list {
    padding: 0;
    margin: 0;
  }

  .feature-item {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 12px;
    margin-left: 16px;
    position: relative;
    line-height: 1.5;
  }
`;

export const StyledPricingSection = styled.section`
  margin: 80px 0px;
  width: inherit;
  border-radius: 16px;

  border: 1px solid #e7e1f1;
  background: linear-gradient(135deg, #fff, #f5f0ff);
  box-shadow: 0 10px 35px rgba(74, 53, 110, 0.06);
  .panel {
    padding: 30px;
  }
  h2 {
    font-size: clamp(36px, 5vw, 54px);
    line-height: 1.08;
    letter-spacing: -0.04em;
  }
  .panel h3 {
    font-size: 24px;
    margin: 0 0 16px;
  }
`;

export const StyledComparisonSection = styled.section`
  .comparison-table {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    margin-top: 30px;
    width: 100%;
    .ant-table {
      font-size: 15px;
    }

    .ant-table-thead > tr > th {
      background-color: #eceef3;
      font-weight: 600;
      font-size: 16px;
      color: #000000;
      border-bottom: 2px solid #e5e7eb;
      padding: 20px 24px;
      text-align: center;
      &:first-of-type {
        text-align: left;
      }
    }

    .ant-table-tbody > tr > td {
      padding: 18px 24px;
      border-bottom: 1px solid #f3f4f6;
      text-align: center;
      font-size: 15px;

      &:first-of-type {
        text-align: left;
        font-weight: 500;
        color: #374151;
      }
    }

    .ant-table-tbody > tr {
      transition: all 0.3s ease;
      &:nth-of-type(even),
      &:hover {
        background-color: #f9fafb;
      }
    }
  }

  .feature-value {
    font-weight: 500;
    color: #6b7280;
  }

  .not-available {
    color: #d1d5db;
    font-size: 20px;
  }

  .cta-section {
    width: 100%;
    margin-top: 30px;
    border-radius: 16px;
    background: linear-gradient(
      135deg,
      ${genericStyles.primaryColor} 0%,
      #6d28d9 100%
    );
    padding: 30px 24px;
    text-align: center;
    @media (max-width: 768px) {
      padding: 60px 24px;
    }
  }

  .cta-title {
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 16px;
    line-height: 1.2;
    @media (max-width: 768px) {
      font-size: 32px;
    }
    @media (max-width: 576px) {
      font-size: 28px;
    }
  }

  .cta-subtitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 400;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  @media (max-width: 768px) {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 16px 12px;
      font-size: 14px;
    }
  }
`;

export const StyledHowItsWorkSection = styled.section`
  padding: 60px 20px !important;
  background: #1d1726;
  color: #fff;
  overflow: hidden;
  border-radius: 20px;
  .section-sub-title {
    color: #bdb5c8;
  }

  .flow {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;
    margin-top: 42px;
    position: relative;
  }
  .flow:before {
    content: "";
    position: absolute;
    left: 6%;
    right: 6%;
    top: 31px;
    height: 2px;
    background: linear-gradient(90deg, #8966c6, #c0a4ee);
  }
  .step {
    position: relative;
    text-align: center;
  }
  .step-num {
    width: 64px;
    height: 64px;
    border-radius: 20px;
    background: #30263e;
    border: 1px solid #5a466f;
    display: grid;
    place-items: center;
    margin: 0 auto 14px;
    font-weight: 900;
    color: #ccb6ed;
  }
  .step h4 {
    margin: 0 0 6px;
    font-size: 15px;
  }
  .step p {
    font-size: 12px;
    color: #afa5ba;
    margin: 0;
  }

  @media (max-width: 950px) {
    .flow {
      grid-template-columns: repeat(3, 1fr);
      row-gap: 30px;
    }
    .flow:before {
      display: none;
    }
  }
  @media (max-width: 650px) {
    .flow {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;

export const StyledFooterSection = styled.section`
  .hero-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }
  .cta {
    padding: 60px;
    border-radius: 30px;
    background: linear-gradient(135deg, #7654b5, #4db882);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
  }
  .cta h2 {
    margin: 0 0 12px;
    font-size: 42px;
  }
  .cta p {
    margin: 0;
    color: #e7dcf7;
  }
  .cta .btn-secondary {
    border-color: rgba(255, 255, 255, 0.35);
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
  }
  @media (max-width: 650px) {
    .cta {
      padding: 34px;
      align-items: flex-start;
      flex-direction: column;
    }
    .cta h2 {
      font-size: 34px;
    }
  }
  footer {
    background: transparent !important;
    padding: 3rem 2rem;
    border-top: 1px solid var(--border);
  }

  .footer-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
  }

  .footer-section h4 {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 1rem;
  }

  .footer-links {
    padding-inline-start: 0px !important;
    list-style: none;
  }

  .footer-links li {
    margin-bottom: 0.5rem;
  }

  .footer-links a {
    color: var(--text-light);
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.3s;
  }

  .footer-links a:hover {
    color: var(--primary);
  }

  .footer-bottom {
    text-align: center;
    padding-top: 2rem;
    margin-top: 2rem;
    border-top: 1px solid var(--border);
    color: var(--text-light);
    font-size: 0.9rem;
  }
`;

export const StyledWhyKelu = styled.section`
  .problem-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-top: 42px;
  }
  .panel {
    border-radius: 16px;
    padding: 30px;
    border: 1px solid #e7e1f1;
    background: #fff;
    box-shadow: 0 10px 35px rgba(74, 53, 110, 0.06);
  }
  .panel h3 {
    font-size: 24px;
    margin: 0 0 16px;
  }
  .tool-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .tool {
    padding: 12px;
    border-radius: 12px;
    background: #faf8fc;
    color: #62596d;
    font-weight: 700;
  }

  .with-kelu {
    background: var(--gradient);
    color: #fff;
    border-color: transparent;
  }
  .with-kelu p {
    color: #eae1f8;
  }

  .check {
    display: flex;
    gap: 10px;
    margin: 11px 0;
  }
  @media (max-width: 950px) {
    .problem-grid {
      grid-template-columns: 1fr;
    }
  }
  @media (max-width: 650px) {
    .tool-list {
      grid-template-columns: 1fr;
    }
  }
`;
